// src/components/Sidebar/MobileMenuButton.jsx
//
// La hamburguesa. Sólo existe por debajo de `md`: de ahí para arriba el rail
// está a la vista y un botón que abre "el menú" al lado de un menú abierto no
// significa nada.
import React from "react";
import { Menu } from "lucide-react";
import { useTranslation } from "react-i18next";
import { useMobileNav } from "./MobileNavContext";
import { cn } from "../../lib/utils";

export function MobileMenuButton({ className }) {
  const { t } = useTranslation();
  const { openMenu } = useMobileNav();

  return (
    <button
      type="button"
      onClick={openMenu}
      aria-label={t("sidebar.openMenu", "Open menu")}
      className={cn(
        // 44px es el mínimo táctil: por debajo de eso el botón se falla con el
        // pulgar, que es el único dedo que se usa acá.
        "inline-flex h-11 w-11 shrink-0 items-center justify-center rounded-2xl",
        "border border-white/12 bg-white/[0.06] text-white transition",
        "hover:bg-white/[0.12] active:bg-white/[0.16]",
        "focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-purple-400/70",
        "md:hidden",
        className
      )}
    >
      <Menu className="h-5 w-5" strokeWidth={2} />
    </button>
  );
}

export default MobileMenuButton;
